import React from 'react';
import { Box } from '@styleseat/ui';
import {
  HeaderText,
} from '../../../ui';
import { IReviewImageSummaryProps } from './types';
import ReviewImageSummaryTrigger from './ReviewImageSummaryTrigger';
import ReviewImageSummaryModalContainer from './ReviewImageSummaryModalContainer';

/**
 * This component renders the ReviewImageSummary area which includes
 * 4 image thumbnails and a read more option.
 * @param provider
 * @param providerId
 * @param previewImages
 * @param onReviewImageShown
 * @param onReviewImageGalleryOpened
 * @constructor
 */
export default function ReviewImageSummary({
  provider,
  providerId,
  previewImages,
  onReviewImageShown,
  onReviewImageGalleryOpened,
  isInReviewTagFiltersTest,
}: IReviewImageSummaryProps) {
  const [openGalleryImageAtIndex, setOpenGalleryImageAtIndex] = React.useState<number | null>(null);

  if (previewImages.results.length < 1) {
    return null;
  }

  const handleOpen = (clickedIndex: number) => {
    setOpenGalleryImageAtIndex(clickedIndex);
    if (typeof onReviewImageGalleryOpened === 'function') {
      onReviewImageGalleryOpened({
        imageCount: previewImages.count,
        id: previewImages.results[clickedIndex].id,
      });
    }

    if (typeof onReviewImageShown === 'function') {
      onReviewImageShown({
        imageIndex: clickedIndex,
        imageCount: previewImages.count,
        id: previewImages.results[clickedIndex].id,
      });
    }
  };

  return (
    <Box
      paddingTop={isInReviewTagFiltersTest ? 0 : 20}
      paddingLeft={12}
    >
      <Box
        paddingBottom={12}
      >
        <HeaderText level={3}>
          Client Photos ({previewImages.count})
        </HeaderText>
      </Box>
      {typeof openGalleryImageAtIndex === 'number'
        && (
          <ReviewImageSummaryModalContainer
            provider={provider}
            onCloseRequest={() => setOpenGalleryImageAtIndex(null)}
            providerId={providerId}
            initialIndex={openGalleryImageAtIndex}
            onReviewImageShown={onReviewImageShown}
          />
        )}
      <ReviewImageSummaryTrigger
        onShowMore={handleOpen}
        previewImages={previewImages.results}
      />
    </Box>
  );
}
